import React from 'react';
import type { FiltersState } from '../types';
import type { TickerInfo } from '../types';
import { formatCompanyName } from '../utils/format';

interface RecommendationFiltersProps {
  filters: FiltersState;
  tickerSearch: string;
  showTickerDropdown: boolean;
  filteredTickers: TickerInfo[];
  onTickerSearchChange: (v: string) => void;
  onTickerDropdownFocus: () => void;
  onTickerDropdownBlur: () => void;
  onTickerSelect: (ticker: string) => void;
  onFilterChange: (key: keyof FiltersState, value: string | number | boolean) => void;
}

export function RecommendationFilters({
  filters,
  tickerSearch,
  showTickerDropdown,
  filteredTickers,
  onTickerSearchChange,
  onTickerDropdownFocus,
  onTickerDropdownBlur,
  onTickerSelect,
  onFilterChange
}: RecommendationFiltersProps) {
  return (
    <div className="filter-section">
      <div className="filter-grid">
        <div className="filter-field">
          <label>Company / Ticker</label>
          <div className="ticker-search-wrapper">
            <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <input
              type="text"
              placeholder="Search..."
              value={tickerSearch}
              onChange={(e) => onTickerSearchChange(e.target.value)}
              onFocus={onTickerDropdownFocus}
              onBlur={onTickerDropdownBlur}
            />
            {showTickerDropdown && filteredTickers.length > 0 && (
              <div className="dropdown">
                {filteredTickers.map((t) => (
                  <button
                    key={t.ticker}
                    className="dropdown-item"
                    onClick={() => onTickerSelect(t.ticker)}
                  >
                    <span className="ticker-symbol">{t.ticker}</span>
                    <span className="ticker-name">{formatCompanyName(t.company_name)}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
          {filters.ticker && (
            <div className="filter-tag">
              <span>{filters.ticker}</span>
              <button onClick={() => onFilterChange('ticker', '')}>×</button>
            </div>
          )}
        </div>

        <div className="filter-field">
          <label>Signal Type</label>
          <select
            value={filters.recommendation_type}
            onChange={(e) => onFilterChange('recommendation_type', e.target.value)}
          >
            <option value="">All Signals</option>
            <option value="BUY">Buy</option>
            <option value="SELL">Sell</option>
            <option value="HOLD">Hold</option>
          </select>
        </div>

        <div className="filter-field">
          <label>Sort By</label>
          <select
            value={filters.sort_by}
            onChange={(e) => onFilterChange('sort_by', e.target.value)}
          >
            <option value="last_updated">Most Recent</option>
            <option value="filing_date">Filing Date</option>
          </select>
        </div>

        <div className="filter-field">
          <label>Show</label>
          <select
            value={filters.limit}
            onChange={(e) => onFilterChange('limit', parseInt(e.target.value))}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>

        <div className="filter-field filter-field-checkbox">
          <label htmlFor="filter-has-trade">Has trade</label>
          <input
            id="filter-has-trade"
            type="checkbox"
            checked={filters.has_trade}
            onChange={(e) => onFilterChange('has_trade', e.target.checked)}
          />
        </div>
      </div>
    </div>
  );
}
